import * as React from 'react';

// COMPONENTS
import ReadActivity from './ReadActivity';
import UpdateActivity from './UpdateActivity';
import DeleteActivity from './DeleteActivity';

// TYPES
import { DashboardActivityFeedActivity } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

export enum ViewTypes {
	Create = 'showCreate',
	Read = 'showRead',
	Update = 'showUpdate',
	Delete = 'showDelete'
}

const defaultViewTypes = {
	[ViewTypes.Create]: false,
	[ViewTypes.Read]: false,
	[ViewTypes.Update]: false,
	[ViewTypes.Delete]: false
};

type ShowViewType = (type: string) => void;

interface ActivityFeedModalTypes {
	viewType: ViewTypes;
	activity?: DashboardActivityFeedActivity;
	closeModal?: closeModalType;
	refreshActivityFeed: () => {};
}

export interface ActivityFeedViewTypes {
	activity?: DashboardActivityFeedActivity;
	showView: ShowViewType;
	closeModal?: closeModalType;
	refreshActivityFeed: () => {};
}

const ActivityFeedModal: React.FC<ActivityFeedModalTypes> = ({
	viewType,
	activity,
	closeModal,
	refreshActivityFeed
}) => {
	const [state, setState] = React.useState({ ...defaultViewTypes, [viewType || ViewTypes.Read]: true });

	const showView: ShowViewType = (viewType) => {
		setState({ ...defaultViewTypes, [viewType]: true });
	};

	if (state.showCreate) {
		return <UpdateActivity showView={showView} closeModal={closeModal} refreshActivityFeed={refreshActivityFeed} />;
	} else if (state.showRead) {
		if (activity) {
			return (
				<ReadActivity
					activity={activity}
					showView={showView}
					closeModal={closeModal}
					refreshActivityFeed={refreshActivityFeed}
				/>
			);
		} else return null;
	} else if (state.showUpdate) {
		return (
			<UpdateActivity
				activity={activity}
				showView={showView}
				closeModal={closeModal}
				refreshActivityFeed={refreshActivityFeed}
			/>
		);
	} else if (state.showDelete) {
		if (activity) {
			return (
				<DeleteActivity
					activity={activity}
					showView={showView}
					closeModal={closeModal}
					refreshActivityFeed={refreshActivityFeed}
				/>
			);
		} else return null;
	} else {
		return null;
	}
};

export default ActivityFeedModal;
